var EUROPEAN_COUNTRIES = [
    'DEU',
    'AUT',
    'CZE',
    'DNK',
    'FIN',
    'NOR',
    'SWE',
    'ITA',
    'HUN',
    'CHE',
    'EST',
    'ROU',
];
var RepresentationService = (function () {
    function RepresentationService($http, $resource, $filter, SCConfiguration) {
        this.$http = $http;
        this.$translate = $filter('scTranslate');
        this.baseUrl = "".concat(SCConfiguration.getEndpoint(), "/api/representation");
        this.resource = $resource("".concat(this.baseUrl, "/:id"), { id: '@_id' }, {
            queryForPlayer: {
                url: "".concat(this.baseUrl, "/player/:playerId"),
                isArray: true,
                method: 'GET',
            },
            queryAvailableAgents: {
                url: "".concat(this.baseUrl, "/search"),
                isArray: true,
                method: 'GET',
            },
            confirmRepresentations: {
                url: "".concat(this.baseUrl, "/confirm"),
                isArray: true,
                method: 'POST',
            },
            confirmCurrentRepresentation: {
                url: "".concat(this.baseUrl, "/confirm-current"),
                isArray: true,
                method: 'POST',
            },
            applyChangesBulk: {
                url: "".concat(this.baseUrl, "/apply-changes"),
                isArray: false,
                method: 'POST',
            },
        });
    }
    RepresentationService.prototype.queryPlayerRerepresentation = function (playerId) {
        return this.resource.queryForPlayer({ playerId: playerId });
    };
    RepresentationService.prototype.queryAvailableAgents = function (query) {
        return this.resource.queryAvailableAgents({ query: query });
    };
    RepresentationService.prototype.confirmRepresentations = function (representationIds) {
        return this.resource.confirmRepresentations({ representationIds: representationIds }).$promise;
    };
    RepresentationService.prototype.applyChangesBulk = function (changes) {
        return this.resource.applyChangesBulk({ changes: changes }).$promise;
    };
    RepresentationService.prototype.wrap = function (record) {
        return new this.resource(record);
    };
    RepresentationService.prototype.createRepresentationTree = function (representations) {
        var _this = this;
        var SORTED_EUROPEAN_COUNTRIES = _.sortBy(EUROPEAN_COUNTRIES, function (country) {
            return _this.$translate("countries.ISO_3.".concat(country));
        });
        var tree = {
            representations: [],
            filter: {},
            leafs: [
                {
                    filter: { region: 'NORTH_AMERICA' },
                    representations: [],
                    leafs: [],
                },
                {
                    filter: { region: 'EUROPE' },
                    representations: [],
                    leafs: SORTED_EUROPEAN_COUNTRIES.map(function (country) {
                        return {
                            filter: { region: 'EUROPE', country: country },
                            representations: [],
                            leafs: [],
                        };
                    }),
                },
                {
                    filter: { region: 'RUSSIA' },
                    representations: [],
                    leafs: [],
                },
                {
                    filter: { region: 'ASIA' },
                    representations: [],
                    leafs: [],
                },
            ],
        };
        assignRepresentationsToTree(tree, representations.slice());
        assignTreeVisibility(tree);
        return tree;
    };
    return RepresentationService;
}());
function assignRepresentationsToTree(tree, representations) {
    tree.leafs.forEach(function (nested) {
        assignRepresentationsToTree(nested, representations);
    });
    tree.representations = representations.filter(function (item) { return _.isMatch(item, tree.filter); });
    _.remove(representations, function (item) { return tree.representations.includes(item); });
}
function assignTreeVisibility(tree) {
    tree.leafs.forEach(function (nested) {
        assignTreeVisibility(nested);
    });
    tree.expanded = tree.leafs.some(function (nested) { return nested.expanded || nested.representations.length > 0; });
}
angular.module('app.profile').service('RepresentationService', RepresentationService);
;